
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  AmCard,
  AmCardHeader,
  AmCardBody,
  AmCardFooter
} from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmSpacing } from "@afe/amui/src/components/Spacing";

@Component({
  components: {
    AmCard,
    AmCardHeader,
    AmCardBody,
    AmCardFooter,
    AmTypography,
    AmButton,
    AmSpacing,
    AmIcon
  }
})
export default class extends Vue {
  @Prop(Object) readonly article!: any;
  @Prop(String) readonly button!: string;
  @Prop({ default: false }) readonly small!: boolean;

  get styles() {
    const image = this.article ? this.article.image : null;
    if (image) {
      return {
        "background-image": `url(${image})`
      };
    }

    return null;
  }
}
